import { render, staticRenderFns } from "./PickupItem.vue?vue&type=template&id=577f19c0"
import script from "./PickupItem.vue?vue&type=script&lang=ts"
export * from "./PickupItem.vue?vue&type=script&lang=ts"
import style0 from "./PickupItem.vue?vue&type=style&index=0&id=577f19c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports